export const LoginTestAttributes = {
    loginContainer: 'login-container',
    emailField: 'email-field',
    passwordField: 'password-field',
    loginButton: 'login-button',
    forgotPasswordLink: 'forgot-password-link',
    forgottenEmailField: 'forgot-email',
    oneTimePasswordField: 'one-time-password',
    forgotPasswordSubmit: 'forgot-password-submit',
    forgotPasswordContainer: 'forgot-password-container',
    forgotPasswordEmailSent: 'forgot-password-email-sent',
    resetPasswordContainer: 'reset-password-container',
    newAccountContainer: 'new-account-container',
    tooManyFailedLoginAttemptsContainer: 'too-many-failed-login-attempts',
    roleSelectorCardParent: 'role-selector-card-parent',
    roleSelectorCardNursery: 'role-selector-card-nursery',
    seeHowFamlyWorks: 'see-how-it-works',
    loginError: 'login-error',
    newPasswordField: 'new-password',
    ssoErrorNotice: 'sso-error-notice',
    passwordNotSetNotice: 'password-not-set-notice',
    sendSetPasswordLinkButton: 'send-set-password-link-button',
    setPasswordLinkSent: 'set-password-link-sent',
    connectToOpenIDProviderButton: 'connect-to-openid-provider',
    openIdAuthenticationError: 'openid-authentication-error',
    openIdAuthenticationErrorTitle: 'openid-authentication-error-title',
    openIdAuthenticationErrorDescription: 'openid-authentication-error-description',
    openIdAuthenticationErrorBackToLogin: 'openid-authentication-error-back-to-login',
    languagePicker: 'language-picker',
    contextChallengeCard: 'context-challenge-card',
    contextChallengeError: 'context-challenge-error',
    contextChallengeLogInAgain: 'context-challenge-log-in-again',
};
